import React from 'react'
import { Image } from './lazyImage'
import rehypeReact from 'rehype-react'

const BGImage = props => <Image sizes={props} />

const renderAst = new rehypeReact({
  createElement: React.createElement,
  components: {
    'bg-image': BGImage,
  },
}).Compiler

const hasASTContent = ast => ast.children.length > 0

export default ({ ast }) => (hasASTContent(ast) ? renderAst(ast) : null)
export { hasASTContent }



// WEBPACK FOOTER //
// ./src/components/utils/renderAst.js